// ThemeContext.js
import React, { createContext, useContext, useState } from "react";
import utils from "./resources/utils";
import _ from "lodash";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("mytheme"); // Default theme name

  const updateTheme = (colors) => {
    const accents_primary =
      !_.isEmpty(colors?.secondary_color) &&
      utils.hexToRgba(colors?.secondary_color, "0.20");
    const generatedTheme = {
      primary: colors?.primary_color || "#492897",
      secondary: colors?.secondary_color || "#7953D2",
      accents: accents_primary || "rgba(121, 83, 210, 0.20)",
    };
    const root = document.documentElement;
    Object.entries(generatedTheme).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
    root.setAttribute("data-theme", "mytheme");
    setTheme("mytheme");
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
